import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'packageTypeValue'
})
export class PackageTypeValuePipe implements PipeTransform {

  transform(value: number): string {
    switch (value) {
      case 0:
        return 'جدید';
      case 1:
        return 'قدیمی';
      case 2:
        return 'هدیه معرفی';
      case 3:
        return 'هدیه پشتیبانی';
      case 4:
        return 'هدیه تولد';
      case 5:
        return 'تمدیدی';
      case 8:
        return 'هدیه پس از خرید';
      case 9:
        return 'خرید عمده';
      case 10:
        return 'سی دی';
      case 11:
        return 'سفارشی';
      case 12:
        return 'آزمایشی';
      case 14:
        return 'تبدیل';
      default:
        return 'نامشخص';
    }
  }





}
